import { isMockMode, post, simulateDelay } from "../api";

export const deleteUpdateSub = (data, isDelete = false) => {
	data.isDeleted = isDelete;

	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(1000, () => testData);
	}

	return post(`Subscriptions/UpdateIssuedSub`, data, {
		successMessage:
			isDelete === true
				? "Subscription successfully deleted"
				: isDelete === false
				? "Subscription successfully updated"
				: null,
	});
};
